import React from 'react'

import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { PostingScreen } from '../../../types/types'
import ButtonComponent from '@professocial/professocialFormComponents/FormComponents/ButtonComponent'
import { PostingTemplate } from '@professocial/professocialTypes/types/commonTypes'
import SellIcon from '@mui/icons-material/Sell'

import { useTranslation } from 'react-i18next'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.body1.fontSize,
    textTransform: 'inherit',
    marginRight: '30px',
  },
  icon: {
    verticalAlign: 'top',
  },
}))

interface IProps {
  posting: PostingTemplate
  changePosting?: (post: PostingTemplate) => void
  changePostingScreen?: (screen: PostingScreen) => void
}

const SelectTags: React.FC<IProps> = (props) => {
  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <>
      <ButtonComponent
        className={classes.root}
        variant='text'
        color='info'
        text={
          <>
            <span style={{ paddingRight: '10px' }}>
              <SellIcon className={classes.icon} style={{ fontSize: '26px' }} />
            </span>
            <span>{t('postingCommon:includeTags')}</span>
          </>
        }
        onClick={() => props.changePostingScreen && props.changePostingScreen(PostingScreen.TAGS)}
      />
    </>
  )
}

export default SelectTags
